import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const financeApiClient = axios.create({
  baseURL: `${BACKEND_URL}/api/finance`,
});

financeApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('financeToken') || localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

financeApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('Finance API: Unauthorized');
    }
    return Promise.reject(error);
  }
);

export default financeApiClient;
